module.exports = __webpack_public_path__ + "img/xinliuPic.0fe94ab1.png";